var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-flex relative justify-center overflow-hidden items-center py-1 text-crm-1 border border-transparent font-medium focus:outline-none",class:[
    _vm.textSize,
    _vm.textColors,
    _vm.borderColor,
    _vm.colorClassname,
    _vm.buttonBorder,
    _vm.fontWeight,
    _vm.truncate,
    {
      'opacity-10 cursor-default hover:opacity-10': _vm.disabled,
      'hover:opacity-70': !_vm.disabled,
      'cursor-default': !_vm.loaded,
      'px-2 leading-3 font-thin': _vm.size === 'small',
      'px-5 py-5': _vm.size === 'smaller',
      'px-12 py-2': _vm.size === 'medium',
      'px-8 font-bold leading-6': _vm.size === 'mediumPlus',
      'px-4 font-bold leading-6': _vm.size === 'thinPlus',
      'leading-5 px-4 font-medium': _vm.size === 'thin',
      'px-3.5': _vm.size === 'thinner',
      'px-3 py-3': _vm.size === 'thinnest',
      'px-2 py-2 font-thin': _vm.size === 'large',
      'px-2 font-thin': _vm.size === 'largeTwo',
      'py-8 px-8 hover:bg-crm-3': _vm.size === 'larger',
      'leading-6 w-42': _vm.size === 'largest',
    } ],attrs:{"type":_vm.type},on:{"click":_vm.onClick}},[(_vm.icon)?_c('div',{staticClass:"p-2.5 bg-no-repeat items-center bg-center",class:[_vm.icon]}):_vm._e(),(!_vm.loaded)?_c('div',{staticClass:"flex items-center justify-center absolute left-0 top-0 bottom-0 right-0",class:[_vm.colorClassname]},[_c('div',{staticClass:"bg-load-icon animate-spin bg-no-repeat h-20 w-20 bg-center"})]):_vm._e(),(!_vm.icon)?_c('div',{staticClass:"w-full text-center py-1",class:{ truncate: _vm.truncate }},[_vm._t("default")],2):_vm._e(),(_vm.rightIcon && !_vm.icon)?_c('div',{staticClass:"p-2 gap-3 ml-3 bg-no-repeat",class:[_vm.rightIcon]}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }